import { AuthUserInfo } from './interface/auth.interface';

export const isBrowser = () => typeof window !== 'undefined';

export const isFacebookInAppBrowser = () => {
  if (isBrowser()) {
    const ua = navigator?.userAgent;

    if ((ua?.indexOf('FBAN') > -1 || ua?.indexOf('FB_IAB') > -1) && ua?.indexOf('FBAV') > -1) {
      return true;
    }
  }
  return false;
};

export const getSignedUpDate = (userInfo: AuthUserInfo) => {
  return userInfo?.createdAt;
};

export const checkIsLocalHost = () => {
  return window.location.origin.includes('localhost');
  // return new Promise(function (resolve) {
  //   const frame = document.createElement('iframe');
  //   frame.id = '3pc';
  //   frame.src = 'https://akropolisio.github.io/3rd-party-cookies-checker/read-cookie.html';
  //   frame.style.display = 'none';
  //   frame.style.position = 'fixed';
  //
  //   setTimeout(() => {
  //     resolve(true);
  //   }, 3000);
  //
  //   const messageHandler = (event) => {
  //     // check for trusted origins here
  //     if (event.data && typeof event.data === 'string') {
  //       console.log('checkThirdPartyCookieEnabled', event);
  //       const isSupported = event.data.includes('unsupported') === false;
  //       window.removeEventListener('message', messageHandler);
  //       document.body.removeChild(frame);
  //       resolve(isSupported);
  //     }
  //   };
  //   window.addEventListener('message', messageHandler);
  //
  //   document.body.appendChild(frame);
  // });
};

export const isInAppBrowser = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  const { userAgent } = window.navigator;

  const userAgentLower = userAgent.toLowerCase();

  // Facebook browsers
  if (
    userAgentLower.includes('fban') ||
    userAgentLower.includes('fbav') ||
    userAgentLower.includes('fb_iab') ||
    userAgentLower.includes('messenger')
  ) {
    return true;
  }

  // Social media apps
  if (userAgentLower.includes('twitter') || userAgentLower.includes('twitterand')) {
    return true;
  }
  if (userAgentLower.includes('instagram')) {
    return true;
  }
  if (userAgentLower.includes('pinterest')) {
    return true;
  }
  if (userAgentLower.includes('linkedin') || userAgentLower.includes('linkedinapp')) {
    return true;
  }
  if (userAgentLower.includes('whatsapp')) {
    return true;
  }
  if (userAgentLower.includes('telegram')) {
    return true;
  }
  if (userAgentLower.includes('zalo')) {
    return true;
  }
  if (userAgentLower.includes('viber')) {
    return true;
  }

  // Search apps
  if (userAgentLower.includes('gsa/')) {
    return true; // Google Search App
  }

  // Other apps
  if (userAgentLower.includes('wechat')) {
    return true;
  }
  if (userAgentLower.includes('line/')) {
    return true;
  }

  return false;
};
